export default "__VITE_ASSET__CiJR9UR3__"